import React, { useState } from "react";
import { CreateCheckoutSession } from "../../services/modules/stripe";
import PrimaryButton from "../ui/PrimaryButton";
import { formatMoneyNumber } from "../../utils/util";

const CardPayment = ({ loanId, installment, customerEmail }) => {
  const [loading, setLoading] = useState(false);

  const amount =
    installment?.total_amount ||
    installment?.principal_remaining + installment?.interest_remaining ||
    0;

  const handlePayWithCard = async () => {
    try {
      setLoading(true);
      const response = await CreateCheckoutSession({
        loanId: Number(loanId),
        installmentId: Number(installment.installment_name),
        amount,
        customerEmail: customerEmail || "",
      });

      const data = Array.isArray(response.resultData) ? response.resultData[0] : response.resultData;
      if (response.resultCode === "20000" && data?.url) {
        window.location.href = data.url;
      } else {
        alert("ไม่สามารถสร้างรายการชำระเงินได้ กรุณาลองใหม่");
      }
    } catch (error) {
      alert("เกิดข้อผิดพลาด: " + (error.message || "กรุณาลองใหม่"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px 0" }}>
      {/* Amount display */}
      <div
        style={{
          border: "2px solid var(--color-primary, #FF6500)",
          borderRadius: 14,
          padding: "20px",
          marginBottom: 20,
          textAlign: "center",
        }}
      >
        <p
          style={{
            fontSize: 14,
            color: "var(--color-text-secondary, #78706E)",
            marginBottom: 8,
          }}
        >
          ยอดชำระ
        </p>
        <p
          style={{
            fontSize: 32,
            fontWeight: 700,
            color: "var(--color-primary, #FF6500)",
          }}
        >
          ฿{formatMoneyNumber(amount)}
        </p>
      </div>

      {/* Stripe info */}
      <div
        style={{
          backgroundColor: "var(--color-bg-gray, #F7F7F7)",
          borderRadius: 10,
          padding: "16px",
          marginBottom: 20,
        }}
      >
        <p
          style={{
            fontSize: 13,
            color: "var(--color-text-secondary, #78706E)",
            lineHeight: 1.6,
          }}
        >
          ระบบจะนำท่านไปยังหน้าชำระเงินของ Stripe
          เพื่อกรอกข้อมูลบัตรเครดิต/เดบิต
          ข้อมูลบัตรของท่านจะถูกเข้ารหัสและปลอดภัย
        </p>
      </div>

      {/* Pay button */}
      <PrimaryButton onClick={handlePayWithCard} disabled={loading || !amount}>
        {loading ? "กำลังดำเนินการ..." : "ชำระด้วยบัตรเครดิต/เดบิต"}
      </PrimaryButton>

      {/* Card logos */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 12,
          marginTop: 16,
          opacity: 0.6,
        }}
      >
        <span style={{ fontSize: 12, color: "#666" }}>Powered by Stripe</span>
      </div>
    </div>
  );
};

export default CardPayment;
